<script>
  import CONFIG from '../config';
  import moment from 'moment';
  import {IntervalType} from '@/models/enums';
  import {DateFormat} from '@/plugins/date-filter';

  export default {
    methods: {
      isWithinTolerance(intervalType, completedAt, unitMetric) {
        if (!unitMetric) {
          return true;
        }
        if (intervalType === IntervalType.Hours) {
          return Math.abs(unitMetric.endingHours - completedAt) <= CONFIG.tolerances.completedAtHours;
        } else if (intervalType === IntervalType.Kilometres) {
          return Math.abs(unitMetric.endingKilometres - completedAt) <= CONFIG.tolerances.completedAtKilometres;
        } else if (intervalType === IntervalType.Months) {
          return true;
        }
      },
      getMessage(completedAt, completedDate, unitMetric, intervalType) {
        const formattedCompletedDate = moment(completedDate).format(DateFormat.DefaultDisplay);
        if (intervalType === IntervalType.Hours) {
                return this.userIsFleetManager
                    ? `${completedAt} is not in range for ${formattedCompletedDate} (${unitMetric.endingHours} +/- ${CONFIG.tolerances.completedAtHours}).`
                    : `${completedAt} is not in range for ${formattedCompletedDate}.`;
        } else if (intervalType === IntervalType.Kilometres) {
                return this.userIsFleetManager
                    ? `${completedAt} is not in range for ${formattedCompletedDate} (${unitMetric.endingKilometres} +/- ${CONFIG.tolerances.completedAtKilometres}).`
                    : `${completedAt} is not in range for ${formattedCompletedDate}`;
        }
      },
      async checkMetricIsInRange(unitId, intervalType, completedAt, completedDate) {
        if (!CONFIG.featureToggles.metricToleranceCheckEnabled) {
          return {
            valid: true
          };
        }

        try {
          const response = await this.$api.get(`units/${unitId}/unit-metric/${completedDate}`);
          const unitMetric = response.data;

          if (!this.isWithinTolerance(intervalType, completedAt, unitMetric)) {
            return {
              valid: false,
              data: {
                message: this.getMessage(completedAt, completedDate, unitMetric, intervalType)
              }
            };
          }
        } catch (error) {
          if (error.response.status === 404) {
            return {
              valid: true
            };
          }
        }

        return {
          valid: true
        };
      }
    }
  };
</script>
